import { Component } from '@angular/core';
import {
  IconoirArrowRight,
  IconoirCheckCircle,
  IconoirCloudUpload,
  IconoirHome,
  IconoirInfoCircle,
  IconoirNavArrowDown,
  IconoirQuestionMark,
  IconoirSearch,
  IconoirWarningCircle,
} from '@ey-xd/motif-icon';
import {
  MotifButtonModule,
  MotifDropdownModule,
  MotifIconModule,
  MotifProgressBarModule,
  MotifTooltipModule,
  SelectComponent,
} from '@ey-xd/ng-motif';

import { CommonModule } from '@angular/common';
import {
  MotifFormsModule,
  MotifProgressIndicatorModule,
} from '@ey-xd/ng-motif';

import { HttpErrorResponse } from '@angular/common/http';
import { ElementRef, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastService } from 'app/core/service/toast/toast.service';
import { ApiFile, ApiItem, ApiJob } from 'app/models/api-response';
import { CoaSummary } from 'app/models/coa-summary';
import { Column, ColumnSet } from 'app/models/columns';
import {
  ColumnDropdown,
  ColumnType,
  DropdownOption,
  SelectedColumn,
} from 'app/models/columns-dropdowns';
import { ProcessStatus } from 'app/models/process-status';
import { TableData } from 'app/models/table-data';
import { ProgressStep } from 'app/models/progress-steps';
import { TableViewComponent } from 'app/shared/components/table-view/table-view.component';
import {
  take,
  Observable,
  forkJoin,
  switchMap,
  of,
  catchError,
  EMPTY,
} from 'rxjs';
import { HeaderTitleService } from 'services/header-title.service';
import { AgentBreadcrumbComponent } from '../components/agent-breadcrumb/agent-breadcrumb.component';
import { CustomMotifDownloaderComponent } from '../components/custom-motif-downloader/custom-motif-downloader.component';
import { CustomMotifUploaderComponent } from '../components/custom-motif-uploader/custom-motif-uploader.component';
import { DisclaimerComponent } from '../components/disclaimer/disclaimer.component';
import { FeedbackComponent } from '../components/feedback/feedback.component';
import { ApiResponseReader } from '../service/api/api-response.service';
import { ChartOfAccountService } from '../service/chart-of-account/chart-of-account.service';
import { FileManipulationService } from '../service/file-manipulation/file-manipulation.service';
import { TbeService } from '../service/tbe/tbe.service';
import { ChartAccountSummaryComponent } from './chart-account-summary/chart-account-summary.component';
import { CoaAgentComponent } from './chart-account/coa-agent.component';
import { TbAgentSummaryComponent } from './tb-agent-summary/tb-agent-summary.component';
import { TbInstructionsComponent } from './tb-instructions/tb-instructions.component';
import { SurveyKey } from 'app/models/feedback-question';
import { AgentId } from 'app/models/agents';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CoAInstructionsComponent } from './coa-instructions/coa-instructions.component';

@Component({
  selector: 'app-tb-agent',
  standalone: true,
  imports: [
    MotifIconModule,
    CommonModule,
    MotifFormsModule,
    MotifProgressIndicatorModule,
    MotifButtonModule,
    MotifProgressBarModule,
    MotifTooltipModule,
    CustomMotifUploaderComponent,
    CustomMotifDownloaderComponent,
    TbAgentSummaryComponent,
    ChartAccountSummaryComponent,
    TableViewComponent,
    AgentBreadcrumbComponent,
    ReactiveFormsModule,
    DisclaimerComponent,
    FeedbackComponent,
    TbInstructionsComponent,
    CoAInstructionsComponent,
    CoaAgentComponent,
    MotifDropdownModule,
  ],
  templateUrl: './tb-agent.component.html',
  styleUrl: './tb-agent.component.scss',
  providers: [],
})
export class TbAgentComponent {
  readonly UPLOAD_FILE_ERROR_TAG = 'uploadFileError';

  IconoirCloudUpload = IconoirCloudUpload;
  IconoirCheckCircle = IconoirCheckCircle;
  IconoirSearch = IconoirSearch;
  IconoirWarningCircle = IconoirWarningCircle;
  IconoirNavArrowDown = IconoirNavArrowDown;
  IconoirInfoCircle = IconoirInfoCircle;
  IconoirHome = IconoirHome;
  IconoirArrowRight = IconoirArrowRight;
  IconoirQuestionMark = IconoirQuestionMark;

  @ViewChildren('fileInput') fileInputs!: QueryList<
    ElementRef<HTMLInputElement>
  >;

  agentOneSteps: ProgressStep[] = [
    {
      stepNumber: 1,
      title: 'Upload Trial Balance',
      status: 'default',
      disabled: true,
    },
    {
      stepNumber: 2,
      title: 'Validate columns selection',
      status: 'default',
      disabled: true,
    },
    {
      stepNumber: 3,
      title: 'Download Cleansed Trial Balance',
      status: 'default',
      disabled: true,
    },
    {
      stepNumber: 4,
      title: 'Upload corrected Trial Balance',
      status: 'default',
      disabled: true,
    },
  ];

  agentTwoSteps: ProgressStep[] = [
    {
      stepNumber: 5,
      title: 'Upload Latest Mapping',
      status: 'default',
      disabled: true,
    },
    {
      stepNumber: 6,
      title: 'Income Statement / Balance Sheet Classification',
      status: 'default',
      disabled: true,
    },
    {
      stepNumber: 7,
      title: 'Upload validated Chart of Account Mapping',
      status: 'default',
      disabled: true,
    },
    {
      stepNumber: 8,
      title: 'Download final Chart of Account Mapping',
      status: 'default',
      disabled: true,
    },
  ];

  currentStep: number = 1;

  // Agent 1 File uploading Steps variables to store file and control errors
  fileToRun: File | any = undefined;
  savedTBFile: ApiFile | undefined = undefined;
  // temporal solution using local storage for this
  tbeUploadedOn: string | null = '';

  fileToRunHasError: boolean | any = false;

  // Params of uploaded file table view
  columnSet?: ColumnSet;
  uploadedFileViewData?: TableData;
  uploadedFileViewColumnsToDisplay?: string[] | any;

  correctedTBFile: File | any = undefined;
  correctedTBFileHasError: boolean | any = false;
  //

  // Agent 2 File uploading Steps variables to store file and control errors
  coaMappingFile: File | any = undefined;
  savedCoaMappingFile: ApiFile | undefined = undefined;
  coaMappedFileToDownload: ApiFile | undefined = undefined;

  coaFinalMappingFile: File | any = undefined;
  coaFinalMappedFileToDownload: any = undefined;
  //

  //Main TB report id, this is the id referencing the TB project in DB
  trialBalanceReportId: string = '';
  tbeColumnSetId: string = '';

  // Agent 1 step two columns dropdown data variables
  columnsDropdowns: ColumnDropdown[] = [];
  additionalColumnsDropdowns: ColumnDropdown[] = [];
  dropdownOptions: DropdownOption[][] = [];

  //form for agent 1 step two columnns
  columnsForm: FormGroup = new FormGroup({});
  @ViewChildren('columnSelect') columnSelects!: QueryList<
    SelectComponent | any
  >;
  //

  // Agent 2 Chart of account dropdown data variables
  chartOfAccountDropdownMappings: ApiItem[] = [];
  selectedCoAOption?: ApiItem = undefined;

  coaBeehiveForm: FormGroup = new FormGroup({
    selectedCoABeehive: new FormControl(),
  });

  // To control Agent 1 spinners
  // step one
  runLoading: boolean = false;
  tbCanceled: boolean = false;
  // step two spinner
  runColumnCleansing: boolean = false;
  columnCleansingCanceled: boolean = false;
  // step four spinner
  loadingAgentTwo: boolean = false;
  //

  // This is to store info for the cleansed file for agent 1
  tbCleansedFile: any = undefined;

  // This is to store info for the TB cleansed file displayed at the top of agent 2
  chartOfAccountTBCleansedFile: any = undefined;

  // step three summary data
  cleansingSummary: any;

  // Step eight summary data
  coaSummary?: CoaSummary | any;

  // process duration messages for agent 1
  stepOneDuration: string = '';
  stepTwoDuration: string = '';

  // process duration messages for agent 2
  stepFiveDuration: string = '';
  stepSevenDuration: string = '';

  // variable to control visibility of agents
  inAgentTwo: boolean = false;

  // the current steps that are showing
  steps: ProgressStep[] = this.agentOneSteps;
  readonly DROPDOWN_LABEL_ACCOUNT_NUMBER = 'Account number';
  readonly DROPDOWN_LABEL_ACCOUNT_DESCRIPTION = 'Account description';
  readonly DROPDOWN_LABEL_TB_AMOUNT = 'Trial balance amount';
  readonly DROPDOWN_LABEL_DEBIT = 'Debit';
  readonly DROPDOWN_LABEL_CREDIT = 'Credit';

  // data to undo the last step of agent 2
  toUndoStep4?: { tb: string };

  get surveyKey(): SurveyKey | undefined {
    if (!this.trialBalanceReportId) {
      return undefined;
    } else {
      return {
        projectId: this.trialBalanceReportId,
        agentId: this.inAgentTwo ? AgentId.COA_MAPPING : AgentId.TRIAL_BALANCE,
      };
    }
  }

  // view last run related variables
  lastSavedStep: number | undefined = 0;
  lastRunButtonDisabled: boolean = true;

  lastSavedStepAgentTwo: number | undefined = 0;

  agentTwoLastRunDisabled: boolean = true;

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(
    private toastService: ToastService,
    private tbeService: TbeService,
    private coaService: ChartOfAccountService,
    private router: Router,
    private titleService: Title,
    private headerTitleService: HeaderTitleService,
    private fileManipulationService: FileManipulationService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(['(max-width: 1020px)'])
      .subscribe((result) => {
        this.isZoomed = result.matches;
      });
  }

  ngOnInit() {
    this.toastService.clearToastWithTag(true);
    this.isThereALatestRunForAgents();
    this.setStepStatus();
  }

  setStepStatus() {
    this.steps.forEach((step) => {
      if (step.stepNumber === this.currentStep) {
        step.status = 'active';
        step.disabled = false;
      } else {
        step.status = 'default'; // these will be handled better based on the last_step var
        step.disabled = true;
      }
    });
  }

  private setStepStatusOnLastRun() {
    let until: number = this.currentStep;

    if (this.inAgentTwo) {
      until = until - 4;
    }

    for (let i = 0; i < until; i++) {
      if (this.steps[i].stepNumber === this.currentStep) {
        this.steps[i].status = 'active';
        this.steps[i].disabled = false;
      } else {
        this.steps[i].status = 'completed';
        this.steps[i].disabled = true;
      }
    }
  }

  /** Stepper control functions  */
  goToNextStep(clearToast: boolean = false) {
    if (clearToast) {
      this.toastService.clearToastWithTag(true);
    }

    let stp: ProgressStep | any = this.steps.find(
      (step) => step.stepNumber === this.currentStep
    );
    if (stp) {
      stp.status = 'completed';
    }
    this.currentStep++;
    stp = this.steps.find((step) => step.stepNumber === this.currentStep);
    stp.status = 'active';
  }

  goToPreviousStep(clearToast: boolean = false) {
    if (clearToast) {
      this.toastService.clearToastWithTag(true);
    }

    if (this.currentStep !== 1) {
      let stp: ProgressStep | any = this.steps.find(
        (step) => step.stepNumber === this.currentStep
      );

      stp.status = 'default';
      stp.disabled = true; //
      this.currentStep--;
      stp = this.steps.find((step) => step.stepNumber === this.currentStep);

      if (stp.status === 'completed') {
        stp.status = 'active';
      }
    }
  }
  /** END Stepper control functions  */

  // Run Trial Balance for excel in step one of agent 1
  runTrialBalance() {
    this.toastService.clearToastWithTag(this.UPLOAD_FILE_ERROR_TAG);
    this.toastService.clearToastWithTag(true);

    // in case we run the trial balance again we must delete this file
    if (this.coaMappedFileToDownload) {
      this.coaMappedFileToDownload = undefined;
    }

    this.runLoading = true;

    this.tbeService
      .postDocumentToTbeCleansing(this.fileToRun)
      .pipe(take(1))
      .subscribe({
        next: (data: ApiResponseReader) => {
          this.trialBalanceReportId = data.trialBalanceId || '';
          this.getInfoForStepTwo();
        },
        error: (error: HttpErrorResponse) => {
          this.runLoading = false;
          if (!error.status) {
            this.toastService.showToast(
              'error',
              'Could not upload the file.' +
                ' A possible cause is that the file is open in another app.' +
                ' Please close the file in other apps and try again.',
              {
                tag: this.UPLOAD_FILE_ERROR_TAG,
                classTheme: '',
                autoHide: false,
              }
            );
          } else {
            this.toastService.showHttpResponseErrorMessage(
              error,
              'Could not upload the file.',
              {
                tag: this.UPLOAD_FILE_ERROR_TAG,
              }
            );
          }
        },
      });
  }

  cancelTrialBalanceRun() {
    this.tbeService
      .deleteTrialBalance(this.trialBalanceReportId)
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          this.runLoading = false;
          this.tbCanceled = true;
        },
        error: (error: HttpErrorResponse) => {
          this.runLoading = false;
          this.tbCanceled = true;
        },
      });
  }

  // Cancel column selection process
  openCancelColumnsToast() {
    this.toastService
      .showToast(
        'warning',
        'If you cancel at this step, you would have to start the Trial Balance process again',
        {
          classTheme: 'motif-theme-light',
          actionText: 'Ok',
          autoHide: false,
        }
      )
      // in this case we consider the .then() case because the toast needs user interaction
      .then((action) => {
        if (action) {
          this.cancelTrialBalanceColumnsRun();
        }
      });
  }

  cancelTrialBalanceColumnsMock() {
    // mock cancel for front to stay on step two of agent 1 (column selection)
    this.runColumnCleansing = false;
    this.columnCleansingCanceled = true;
  }

  private cancelTrialBalanceColumnsRun() {
    //here we are in step two while loading so we just have to go one step back
    this.tbeService
      .deleteTrialBalance(this.trialBalanceReportId)
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          this.runColumnCleansing = false;
          this.columnCleansingCanceled = true;
          this.goToPreviousStep(true); // GO TO STEP 1
        },
        error: (error: HttpErrorResponse) => {
          this.runColumnCleansing = false;
          this.columnCleansingCanceled = true;
          this.goToPreviousStep(true); // GO TO STEP 1
        },
      });
  }

  // Get data for agent 1 step two to populate the columns
  getInfoForStepTwo() {
    // if it was canceled, set the canceled variable and timer to base and
    // dont continue with the get info
    if (this.tbCanceled) {
      this.tbCanceled = false;
      return;
    }

    if (this.columnSet) {
      this.columnSet = undefined;
    }

    this.tbeService
      .getLatestTBE(this.trialBalanceReportId)
      .pipe(take(1))
      .subscribe({
        next: (data: ApiResponseReader) => {
          const status: number = data.status;
          const files: ApiFile[] = data.files;
          const jobs: ApiJob[] = data.jobs;
          const createdAt: string | undefined = data.createdAt;

          this.setFileVariables(files, { forTbe: true });
          this.tbeUploadedOn = createdAt!;

          if (status === ProcessStatus.WaitingForUser) {
            // 25 is waiting for user, go to column selection
            this.loadInitialTBEFile();

            const columnSet = data.columnSet!;
            this.columnSet = columnSet;
            this.tbeColumnSetId = columnSet.id!;

            this.setUpDropdownsAndColumns(columnSet);

            this.runLoading = false;
            const duration: number | undefined = this.getJobByType(
              jobs,
              10
            )?.time_ms;
            this.stepOneDuration = `Trial Balance Key Column Selection process completed in ${
              duration! / 1000
            } sec.`;
            this.goToNextStep(true); // GO TO STEP 2
          } else if (
            status === ProcessStatus.Created ||
            status === ProcessStatus.Running
          ) {
            // 10 & 20 are running
            setTimeout(() => {
              this.getInfoForStepTwo();
            }, 15000);
          } else {
            // 40 or others are Failures
            this.runLoading = false;
            // if the process was canceled and we get here
            // we set it to the base state and avoid the message to appear
            if (this.tbCanceled) {
              this.tbCanceled = false;
            } else {
              this.toastService.showToast(
                'error',
                `Trial Balance process failed. Run the process again. If the error persist, please contact servicedesk@ey.com`,
                {
                  classTheme: '',
                  autoHide: false,
                }
              );
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          this.runLoading = false;
          // if the process was canceled and we get here
          // we set it to the base state and avoid the message to appear
          if (this.tbCanceled) {
            this.tbCanceled = false;
          } else {
            this.toastService.showHttpResponseErrorMessage(error);
          }
        },
      });
  }

  // to force sort in the component HTML motif-select
  // an sort the dropdown options by id
  sortById(a: any, b: any): number {
    return a.id - b.id;
  }

  // out-sourcing of this chunk of code that repeats a lot in the class
  private setUpDropdownsAndColumns(columnSet: ColumnSet) {
    const dropdownColumns = this.generateDropdownColumns(
      columnSet.selected_columns!
    );

    // must edit id and add 1 because if the id is 0 the dropdown acts funny with that option
    this.columnsDropdowns = dropdownColumns.map((selectedColumn: Column) => {
      const dropdown = new ColumnDropdown(
        selectedColumn.id !== undefined ? selectedColumn.id! + 1 : null,
        selectedColumn.type!,
        selectedColumn.name!,
        selectedColumn.selected_by_ai!,
        this.getDropdownLabel(selectedColumn)
      );
      if (selectedColumn.id === undefined) {
        dropdown.greyedOut = true;
      }
      return dropdown;
    });

    // initialize the columnsForm with the selected_by_ai columns
    this.columnsDropdowns.forEach((col, index) => {
      //let's add the column-index as formControlName
      this.columnsForm.addControl(`column-${index}`, new FormControl());
      // set the value as the id of the selected_by_ai
      this.columnsForm.get(`column-${index}`)?.setValue(col.id);
    });

    this.dropdownOptions = this.columnsDropdowns.map(
      (columnDropdown: ColumnDropdown) =>
        columnSet.all_columns!.map((column: Column) => {
          // We pass a temporary display name to the constructor,
          // and then set the correct one.

          const option = new DropdownOption(
            column.name!,
            column.name!,
            column.id! + 1
          );

          option.displayName = this.getColumnDropdownOptionDisplayName(
            columnDropdown,
            option
          );

          return option;
        })
    );

    this.updateColumnsToDisplay();
  }

  private loadInitialTBEFile(selectedColumnsNames?: string[]): void {
    const columnSetId: string | undefined = this.columnSet?.id;

    let selectedColumns: SelectedColumn[] | undefined;
    let isMissingColumnSelection: boolean = false;

    if (!selectedColumnsNames) {
      selectedColumns = undefined;
    } else {
      const filteredColumnsDropdowns = this.getFilteredColumnsDropdowns();

      selectedColumns = [];

      GetSelectedColumns: for (
        let i = 0;
        i < filteredColumnsDropdowns.length;
        i++
      ) {
        const columnType = filteredColumnsDropdowns[i].type;
        const selectedColumnName = selectedColumnsNames[i];
        const selectedColumn = this.columnSet!.all_columns!.find(
          (col: Column) => col.name === selectedColumnName
        );
        if (selectedColumn) {
          selectedColumns.push({
            id: selectedColumn.id,
            type: columnType,
          });
        } else {
          isMissingColumnSelection = true;
          break GetSelectedColumns;
        }
      }
    }

    if (isMissingColumnSelection) {
      // Do not fetch TBE preview: the user has not selected all columns.
      return;
    }

    if (this.uploadedFileViewData) {
      this.uploadedFileViewData = undefined;
    }

    this.tbeService
      .getInitialUploadedTBE(
        this.trialBalanceReportId,
        columnSetId,
        selectedColumns
      )
      .pipe(take(1))
      .subscribe({
        next: (data: ApiResponseReader) => {
          this.columnSet = data.columnSet!;
          this.uploadedFileViewData = data.validatedDF!;
          const labels = this.getFilteredColumnsDropdowns().map(
            (cdrop) => cdrop.label
          );
          // this is modified like this because the headers on the columns
          // should be the same as the ones on the dropdowns and should not
          // change on dropdown value change
          this.uploadedFileViewData = {
            ...this.uploadedFileViewData,
            labels: labels,
          };
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.showHttpResponseErrorMessage(
            error,
            "Could not read the uploaded file's data."
          );
        },
      });
  }
  private generateDropdownColumns(columnSetColumns: Column[]): Column[] {
    const map_columnType_column: Map<number, Column> = new Map();
    for (const column of columnSetColumns) {
      map_columnType_column.set(column.type!, column);
    }

    const columns = [];

    columns.push(map_columnType_column.get(ColumnType.AccountCode)!);

    columns.push(map_columnType_column.get(ColumnType.AccountDescription)!);

    let trialBalanceColumn = map_columnType_column.get(ColumnType.TrialBalance);
    if (!trialBalanceColumn) {
      trialBalanceColumn = new Column(
        undefined,
        ColumnType.TrialBalance,
        'Trial Balance',
        false
      );
    }
    columns.push(trialBalanceColumn);

    let debitColumn = map_columnType_column.get(ColumnType.Debit);
    if (!debitColumn) {
      debitColumn = new Column(undefined, ColumnType.Debit, 'Debit', false);
    }
    columns.push(debitColumn);

    let creditColumn = map_columnType_column.get(ColumnType.Credit);
    if (!creditColumn) {
      creditColumn = new Column(undefined, ColumnType.Credit, 'Credit', false);
    }
    columns.push(creditColumn);

    return columns;
  }

  private updateColumnsToDisplay() {
    const filteredColumnsDropdowns = this.getFilteredColumnsDropdowns();

    this.uploadedFileViewColumnsToDisplay = filteredColumnsDropdowns.map(
      (columnDropdown: ColumnDropdown) => columnDropdown.selectedName
    );

    if (this.uploadedFileViewData) {
      this.uploadedFileViewData.labels = filteredColumnsDropdowns.map(
        (cdrop) => cdrop.label
      );
    }
  }

  // Now this is properly managed and the events trigger how they should
  // value is the selected option id (number)
  onSelectionChange(
    value: number,
    dropdownIndex: number,
    columnsDropdowns: ColumnDropdown[] = this.columnsDropdowns,
    dropdownOptions: DropdownOption[][] = this.dropdownOptions
  ) {
    const dropdownInList = columnsDropdowns[dropdownIndex];

    const option = dropdownOptions[dropdownIndex].find(
      (opt: any) => opt.id === value
    );

    if (option) {
      dropdownInList.selectedId = option.id;
      dropdownInList.selectedName = option.name;
    }

    this.updateColumnsToDisplay();

    this.loadInitialTBEFile(this.uploadedFileViewColumnsToDisplay);

    // to regain focus on the dropdown after selecting an option
    const columnSelect: SelectComponent = this.columnSelects.get(dropdownIndex);
    if (columnSelect) {
      const element =
        columnSelect?.trigger.nativeElement.offsetParent.children[1]
          .children[0];

      element.classList.add('cdk-focused');
      element.setAttribute('tabindex', '0');
      element.focus();
    }
  }

  // Send the data in the columns to clean the TB report
  confirmAndCleanData() {
    const columns = {
      id: this.tbeColumnSetId, // but here it must be pointing to the TBE Columns collection
      selected_columns: this.getFilteredColumnsDropdowns().map((column) => ({
        id: column.selectedId! - 1,
        type: column.type,
      })),
    };

    this.runColumnCleansing = true;

    this.tbeService
      .postSendColumnsAndStartCleansing(this.trialBalanceReportId, columns)
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          this.getLatestTBEForStepThree(); // get the data for the next step after selecting columns
        },
        error: (error: HttpErrorResponse) => {
          this.runColumnCleansing = false;

          this.toastService.showHttpResponseErrorMessage(error);
        },
      });
  }

  // Get Data for step three of agent 1
  getLatestTBEForStepThree() {
    // if it was canceled, set the canceled variable and timer to base and
    // dont continue with the get info
    if (this.columnCleansingCanceled) {
      this.columnCleansingCanceled = false;
      return;
    }

    this.tbeService
      .getLatestTBE(this.trialBalanceReportId)
      .pipe(take(1))
      .subscribe({
        next: (data: ApiResponseReader) => {
          const status: number = data.status;
          const files: ApiFile[] = data.files;
          const jobs: ApiJob[] = data.jobs;
          const createdAt: string | undefined = data.createdAt;

          if (
            status === ProcessStatus.Completed ||
            status === ProcessStatus.WaitingForUser
          ) {
            // 30 is success, 25 is waiting for user
            this.setFileVariables(files, { forTbe: true });
            this.tbeUploadedOn = createdAt!;

            // format the name in cases the file starts with "TB-"
            // const cleanedFilename = this.savedTBFile?.filename!.replace(
            //   /^TB-/,
            //   ''
            // );

            // format the name in cases the file starts with "TB-" and remove extension
            const cleanedFilename = this.savedTBFile?.filename!.replace(
              /^TB-/,
              ''
            ).replace(/\.[^/.]+$/, '');
 
            this.tbCleansedFile.filename =
              `AI Generated Cleansed TB ${cleanedFilename}.xlsx`;

            // // Put a fixed filename to avoid using the generated one with the id
            // this.tbCleansedFile.filename =
            //   `AI Generated Cleansed TB ` + `${cleanedFilename}`;

            this.cleansingSummary = data.cleansingSummary;

            const duration: number | undefined = this.getJobByType(
              jobs,
              11
            )?.time_ms;
            this.stepTwoDuration = `Trial Balance cleansing completed in ${
              duration! / 1000
            } sec.`;
            this.runColumnCleansing = false;
            this.goToNextStep(true); // GO TO STEP 3
          } else if (
            status === ProcessStatus.Created ||
            status === ProcessStatus.Running
          ) {
            // 10 & 20 are running
            setTimeout(() => {
              this.getLatestTBEForStepThree();
            }, 15000);
          } else {
            // 40 or others are Failures
            this.runColumnCleansing = false;
            // if the process was canceled and we get here
            // we set it to the base state and avoid the message to appear
            if (this.columnCleansingCanceled) {
              this.columnCleansingCanceled = false;
            } else {
              this.toastService.showToast(
                'error',
                `Column cleansing process failed. Run the process again. If the error persist, please contact servicedesk@ey.com`,
                {
                  classTheme: '',
                  autoHide: false,
                }
              );
            }
          }
        },
        error: (error: any) => {
          this.runColumnCleansing = false;
          // error when getting the latest TBE
          if (this.columnCleansingCanceled) {
            this.columnCleansingCanceled = false;
          } else {
            this.toastService.showHttpResponseErrorMessage(error);
          }
        },
      });
  }
  private getFilteredColumnsDropdowns(): ColumnDropdown[] {
    return this.columnsDropdowns.filter((cdrop) => !cdrop.greyedOut);
  }

  onDropdownClick(dropdown: ColumnDropdown): void {
    switch (dropdown.type) {
      case ColumnType.TrialBalance:
        this.setColumnDropdownGreyedOut(ColumnType.TrialBalance, false);
        this.setColumnDropdownGreyedOut(ColumnType.Debit, true);
        this.setColumnDropdownGreyedOut(ColumnType.Credit, true);
        break;

      case ColumnType.Debit:
      case ColumnType.Credit:
        this.setColumnDropdownGreyedOut(ColumnType.TrialBalance, true);
        this.setColumnDropdownGreyedOut(ColumnType.Debit, false);
        this.setColumnDropdownGreyedOut(ColumnType.Credit, false);
        break;
    }
    //test
    this.updateColumnsToDisplay();
    this.loadInitialTBEFile(this.uploadedFileViewColumnsToDisplay);
  }

  private setColumnDropdownGreyedOut(type: ColumnType, greyedOut: boolean) {
    const dropdown = this.columnsDropdowns.find((cdrop) => cdrop.type === type);
    if (dropdown) {
      dropdown.greyedOut = greyedOut;
    }
  }

  // Step four of agent 1, Complete the TB
  completeTrialBalanceProject() {
    const fileToComplete: File | null = this.correctedTBFile || null;

    this.loadingAgentTwo = true;
    this.inAgentTwo = true; // we move to agent two

    // only way to set the title as we need to pass through agent 1 to get to agent 2
    this.setTitle('UK Chart of Account Mapping Agent | CIT Agent');

    const tb = this.trialBalanceReportId;

    this.toUndoStep4 = { tb };

    this.tbeService
      .completeTrialBalance(tb, fileToComplete)
      .pipe(take(1))
      .subscribe({
        next: (data: ApiResponseReader) => {
          const files: ApiFile[] = data.files;

          this.setFileVariables(files, { forTbe: true });
          // this function checks if the type 10 file exists,
          // in case it does not, choose the type 9
          this.chartOfAccountTBCleansedFile =
            this.fileManipulationService.getCleansedFile(files, true);

          // if the type is 9, we hardcode the name to make reference to the AI generated
          // the other case is the type 10, which means we uploaded a file in step 4 of agent 1
          if (this.chartOfAccountTBCleansedFile.type === 9) {
            // format the name in cases the file starts with "TB-"
            const cleanedFilename = this.savedTBFile?.filename!.replace(
              /^TB-/,
              ''
            );

            this.chartOfAccountTBCleansedFile.filename =
              `AI Generated Cleansed TB` + `${cleanedFilename}`;
          }

          this.loadingAgentTwo = false;

          this.steps = this.agentTwoSteps; // change the visible steps
          this.getCoADropdownMappings(); // get data for dropdown

          this.goToNextStep(true); //GO TO STEP 5 (Step 1 of agent 2)
        },
        error: (error: HttpErrorResponse) => {
          this.loadingAgentTwo = false;
          this.toastService.showHttpResponseErrorMessage(error);
        },
      });
  }

  // Get values for Chart of Account mappings dropdown
  getCoADropdownMappings() {
    this.coaService
      .getMappingIndexes()
      .pipe(take(1))
      .subscribe({
        next: (data: ApiResponseReader) => {
          this.chartOfAccountDropdownMappings = data.rawResponse.items || [];
        },
        error: (error: HttpErrorResponse) => {
          const message: string =
            error.error?.message ||
            'An unexpected error occurred getting indexes for Chart of account mappings dropdown';
          console.error(message);
        },
      });
  }

  goBackToAgentOneAfterUndo(): void {
    this.toUndoStep4 = undefined;

    this.steps.forEach((step) => {
      step.status = 'default';
      step.disabled = true;
    });

    this.inAgentTwo = false;
    this.setTitle('Trial Balance Extraction Agent | CIT Agent');

    this.steps = this.agentOneSteps;
    this.currentStep = 4;

    this.steps.forEach((step) => {
      if (step.stepNumber === this.currentStep) {
        step.status = 'active';
        step.disabled = true;
      } else {
        step.status = 'completed';
        step.disabled = false;
      }
    });
  }

  setCoaSummary(event: CoaSummary) {
    this.coaSummary = event;
  }

  setcoaMappedFileToDownload(event: any) {
    this.coaMappedFileToDownload = event;
  }

  // on selection of chart of account mapping
  // the id is passed as a string when selected
  onChartMappingType(option: string, element: HTMLElement | any) {
    const mapping = this.chartOfAccountDropdownMappings.find(
      (mp) => mp.id === option
    );

    if (mapping) {
      this.selectedCoAOption = mapping;
      localStorage.setItem('selectedCoAOption', JSON.stringify(mapping));
    }

    setTimeout(() => {
      element.focus();
    }, 0);
  }

  // Handle file selection functions for Agent 1 file uploaders
  onFileSelected(event: Event): void {
    this.fileToRun = event;
  }

  onFileHasError(event: boolean): void {
    this.fileToRunHasError = event;
  }

  onCorrectedTrialBalanceUploaded(event: Event): void {
    this.correctedTBFile = event;
  }

  onCorrectedTrialBalanceFileHasError(event: boolean): void {
    this.correctedTBFileHasError = event;
  }
  /**
   * END OF Handle file funtions selection for Agent 1 file uploaders
   **/

  /**
   * Private and utility functions
   * */
  private getDropdownLabel(column: Column): string {
    switch (column.type) {
      case ColumnType.AccountCode:
        return this.DROPDOWN_LABEL_ACCOUNT_NUMBER;
      case ColumnType.AccountDescription:
        return this.DROPDOWN_LABEL_ACCOUNT_DESCRIPTION;
      case ColumnType.TrialBalance:
        return this.DROPDOWN_LABEL_TB_AMOUNT;
      case ColumnType.Debit:
        return this.DROPDOWN_LABEL_DEBIT;
      case ColumnType.Credit:
        return this.DROPDOWN_LABEL_CREDIT;
      default:
        return '';
    }
  }

  /** View last run related functions */
  private isThereALatestRunForAgents() {
    const tbeLatest$: Observable<ApiResponseReader> =
      this.tbeService.getLatestTBEWithoutID();

    // We first need the trialBalanceId, so we use switchMap in a pipe step
    tbeLatest$
      .pipe(
        take(1),
        switchMap((tbeData: ApiResponseReader) => {
          const tbeId: string | undefined = tbeData.trialBalanceId;

          if (!tbeId) {
            return EMPTY;
          }

          this.trialBalanceReportId = tbeId!;

          const coaLatest$: Observable<ApiResponseReader | null> =
            this.coaService.getCoaProject(this.trialBalanceReportId).pipe(
              catchError((error) => {
                return of(null); // fallback value
              })
            );

          const tableDataLatest$: Observable<ApiResponseReader> =
            this.tbeService.getInitialUploadedTBE(this.trialBalanceReportId);

          return forkJoin([of(tbeData), coaLatest$, tableDataLatest$]);
        })
      )
      .subscribe({
        next: ([tbeData, coaData, tableData]: [
          ApiResponseReader,
          ApiResponseReader | null,
          ApiResponseReader
        ]) => {
          /** Set needed tbeData variables */
          const tbeStatus: number = tbeData.status;
          const tbeLastStep: number | undefined = tbeData.lastStep;
          const tbeFiles: ApiFile[] = tbeData.files;
          const tbeCleansingSummary = tbeData.cleansingSummary;
          const tbeJobs: ApiJob[] = tbeData.jobs;

          const columnSet = tbeData.columnSet!;
          this.columnSet = columnSet;
          this.tbeColumnSetId = columnSet.id!;

          const tbeCreatedAt: string | undefined = tbeData.createdAt;
          /** */

          /** Set needed tableData variables */
          const validatedDF = tableData.validatedDF!;
          /** */

          /**Logic for variable assignation for tbe */
          if (
            tbeStatus === ProcessStatus.Completed ||
            (tbeStatus === ProcessStatus.WaitingForUser && tbeLastStep === 30)
          ) {
            this.lastSavedStep = tbeLastStep! / 10;
            this.cleansingSummary = tbeCleansingSummary;
            this.setFileVariables(tbeFiles, { forTbe: true });
            this.setJobDurations(tbeJobs, { forTbe: true });
            this.tbeUploadedOn = tbeCreatedAt!;
            // Put a fixed filename to avoid using the generated one with the long name
            if (this.tbCleansedFile) {
              // format the name in cases the file starts with "TB-"
              const cleanedFilename = this.savedTBFile?.filename!.replace(
                /^TB-/,
                ''
              );

              this.tbCleansedFile.filename =
                `AI Generated Cleansed TB ` + `${cleanedFilename}`;
            }
            // Set this variable for agent two cleansed TB that is at the top
            this.chartOfAccountTBCleansedFile = this.tbCleansedFile;
          }

          // if we are in the status waiting for user and we were on step 2
          if (
            tbeStatus === ProcessStatus.WaitingForUser &&
            tbeLastStep === 10
          ) {
            this.lastSavedStep = tbeLastStep! / 10 + 1;
            this.setFileVariables(tbeFiles, { forTbe: true });
            this.setJobDurations(tbeJobs, { forTbe: true });
            this.tbeUploadedOn = tbeCreatedAt!;
          }

          // Set variables for columns and table from tbe step 2
          this.uploadedFileViewData = validatedDF;
          const labels = this.getFilteredColumnsDropdowns().map(
            (cdrop) => cdrop.label
          );
          this.uploadedFileViewData = {
            ...this.uploadedFileViewData,
            labels: labels,
          };
          this.setUpDropdownsAndColumns(columnSet);
          // enable the button for view last run
          this.lastRunButtonDisabled = false; // <-
          /** */

          /** Set needed coaData variables and add Logic for variable assignation for coa */
          if (coaData) {
            const coaLastStep: number | undefined = coaData.lastStep;
            const coaFiles: ApiFile[] = coaData.files;
            const coaJobs: ApiJob[] = coaData.jobs;
            const coaSummary = coaData.coaSummary;

            this.lastSavedStepAgentTwo = coaLastStep! / 10 + 4;

            this.setFileVariables(coaFiles, { forCoa: true });
            this.setJobDurations(coaJobs, { forCoa: true });

            this.coaSummary = coaSummary;
            this.agentTwoLastRunDisabled = false;
          }
          /** */
        },
        error: (error: HttpErrorResponse) => {
          // optional error handling as we are just really getting data
        },
      });
  }

  private setFileVariables(
    files: ApiFile[],
    flags?: { forTbe?: boolean; forCoa?: boolean }
  ) {
    if (flags?.forTbe) {
      // retrieve and set the original TB file
      this.savedTBFile = this.fileManipulationService.getCleansedFile(
        files,
        false,
        8
      );

      // retrieve and set the cleansed TB file
      this.tbCleansedFile = this.fileManipulationService.getCleansedFile(
        files,
        false,
        9
      );
    }

    if (flags?.forCoa) {
      // retrieve and set the generated file on Chart of account step 2
      this.coaMappedFileToDownload =
        this.fileManipulationService.getCleansedFile(files, false, 11);

      // and set the name to avoid using the long generated name
      if (this.coaMappedFileToDownload) {
        this.coaMappedFileToDownload!.filename =
          'AI Generated Income Statement / Balance Sheet Classification.xlsx';
      }

      // retrieve and set the generated final output on Chart of account step 4
      this.coaFinalMappedFileToDownload =
        this.fileManipulationService.getCleansedFile(files, false, 13);

      // and set the name to avoid using the long generated name
      if (this.coaFinalMappedFileToDownload) {
        this.coaFinalMappedFileToDownload.filename =
          'AI Generated Final Chart of Account Mapping.xlsx';
      }

      // retrieve and set the file we uploaded on Chart of account step 1
      this.savedCoaMappingFile = this.fileManipulationService.getCleansedFile(
        files,
        false,
        14
      );
    }
  }

  private setJobDurations(
    jobs: ApiJob[],
    flags?: { forTbe?: boolean; forCoa?: boolean }
  ) {
    if (flags?.forTbe) {
      const durationStepOne: number | undefined =
        this.getJobByType(jobs, 10)?.time_ms || 1;

      const durationStepTwo: number | undefined =
        this.getJobByType(jobs, 11)?.time_ms || 1;

      this.stepOneDuration = `Trial Balance Key Column Selection process completed in ${
        durationStepOne! / 1000
      } sec.`;
      this.stepTwoDuration = `Trial Balance cleansing completed in ${
        durationStepTwo! / 1000
      } sec.`;
    }

    if (flags?.forCoa) {
      const durationStepFive: number | undefined =
        this.getJobByType(jobs, 20)?.time_ms || 1;

      const durationStepSeven: number | undefined =
        this.getJobByType(jobs, 21)?.time_ms || 1;

      this.stepFiveDuration = `Level 1 Account Mapping completed in ${
        durationStepFive! / 1000
      } sec.`;
      this.stepSevenDuration = `Final Account Mapping completed in ${
        durationStepSeven! / 1000
      } sec.`;
    }
  }

  goToAgentOneLastRun() {
    this.currentStep = this.lastSavedStep!;
    this.setStepStatusOnLastRun();
  }

  goToAgentTwoLastRun() {
    this.getCoADropdownMappings();
    this.inAgentTwo = true;
    this.steps = this.agentTwoSteps;
    this.currentStep = this.lastSavedStepAgentTwo!;
    this.setStepStatusOnLastRun();
    this.setTitle('UK Chart of Account Mapping Agent | CIT Agent');
  }
  /** END View last run related functions */

  onNavigateBackToAgentOne() {
    this.toastService.clearToastWithTag(true);
    this.inAgentTwo = false;
    this.setTitle('Trial Balance Extraction Agent | CIT Agent');
    this.currentStep = 1;
    this.fileToRun = undefined;
    this.steps = this.agentOneSteps;
    this.setStepStatus();
    //
    this.tbeColumnSetId = '';
    this.columnSet = undefined;
  }

  // convenient function to help display the [AI-selected] label on the options
  getColumnDropdownOptionDisplayName(
    dropdown: ColumnDropdown,
    option: DropdownOption
  ): string {
    if (
      dropdown.selectedId === option.id &&
      dropdown.selectedName === option.name &&
      dropdown.selected_by_ai
    ) {
      return option.name + ' [AI-selected]';
    } else {
      return option.name;
    }
  }

  backHome() {
    this.router.navigate(['/home']);
  }

  scrollUp() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Adds smooth scrolling effect
    });
  }

  private setTitle(title: string): void {
    this.headerTitleService.setCustomTitle(title);
    this.titleService.setTitle(title);
  }

  private getJobByType(jobs: ApiJob[], type: number) {
    const job = jobs.find((j: ApiJob) => j.type === type);

    if (job) {
      return job;
    }
    return undefined;
  }
}
